import type { AuthChangeEvent, Session, SignInWithPasswordCredentials, SignUpWithPasswordCredentials } from '@supabase/supabase-js'

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.VITE_SUPABASE_URL || process.env.SUPABASE_URL
const supabaseKey = process.env.SUPABASE_SERVICE_ROLE_KEY || process.env.VITE_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables')
}

// private, do not expose
const supabaseClient = createClient(supabaseUrl, supabaseKey, {
  auth: {
    throwOnError: true,
  }
})

export const authClient = {
  useFake: null as (Session | null),
  async getSession() {
    if (this.useFake) {
      return this.useFake
    }
    return (await supabaseClient.auth.getSession()).data.session
  },
  getUser: (jwt: string) => {
    return supabaseClient.auth.getUser(jwt)
  },
  onAuthStateChange(callback: (event: AuthChangeEvent, session: Session | null) => void) {
    if (this.useFake) {
      return
    }
    return supabaseClient.auth.onAuthStateChange(callback)
  },
  signUp: (credentials: SignUpWithPasswordCredentials) => {
    return supabaseClient.auth.signUp(credentials)
  },
  signInWithPassword: (credentials: SignInWithPasswordCredentials) => {
    return supabaseClient.auth.signInWithPassword(credentials)
  },
  signOut: () => {
    return supabaseClient.auth.signOut()
  }
}